export default "__VITE_ASSET__C4OBdKb4__"